/**
 * 検証プレイグラウンドサービス
 * 
 * runPlayground APIとの通信を担当
 */

import { httpsCallable } from 'firebase/functions';
import { getFunctionsInstance } from '../lib/firebase';

/**
 * 検証ステップの結果
 */
export interface PlaygroundStep {
  name: string;
  status: 'success' | 'error' | 'skipped' | 'warning';
  description?: string;
  durationMs?: number;
}

/**
 * 名寄せ候補
 */
export interface NormalizeCandidate {
  partnerId: string;
  officialName: string;
  matchType: 'exact_pattern' | 'fuzzy_official_name' | 'fuzzy_pattern' | 'ai';
  matchedPattern?: string;
  similarity?: number;
}

/**
 * 検証結果
 */
export interface PlaygroundResult {
  success: boolean;
  steps: PlaygroundStep[];
  ocrResult?: {
    structuredData: Record<string, unknown>;
    text: string;
    promptUsed?: string;
  };
  csvPreview?: {
    content: string;
    filename: string;
    encoding: string;
    rows: string[][];
  };
  emailPreview?: {
    to: string[];
    subject: string;
    attachmentName: string;
  };
  /** 伝票種別検出結果 */
  slipTypeDetection?: {
    detected: string;
    configSource: string;
  };
  normalizeDetails?: {
    inputName: string;
    candidates: NormalizeCandidate[];
    matchType?: string;
    matchedPattern?: string;
    allPartners: { id: string; name: string; patterns: string[] }[];
  };
  error?: string;
}

/**
 * 検証プレイグラウンドを実行
 */
export async function runPlayground(params: {
  customerId: string;
  partnerId: string;
  fileBase64: string;
  mimeType: string;
  fileName: string;
}): Promise<PlaygroundResult> {
  const functions = getFunctionsInstance();
  const fn = httpsCallable<typeof params, PlaygroundResult>(functions, 'runPlayground');
  const result = await fn(params);
  return result.data;
}
